import {topic} from "api/restApi";

export const localRead = (key) => {
  return localStorage.getItem(key) || ''
}

// 获取url参数
const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// 金额千分位
const thousands = (input) => {
  return input && input.toString()
      .replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

// 时间格式化
Date.prototype.Format = function (fmt) { //author: heyan
  let o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

// josn化参数
const objectToQueryString = (obj) => {
  let str = [];
  for (let p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return `?${str.join("&")}`;
}

// queryString to obj
const getParameter = (name,all) => {
  const query = decodeURIComponent(window.location.search.substring(1));
  if(!query) return {};
  let vars = query.split('&');
  let queryString = {};
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    // If first entry with this name
    if (typeof queryString[pair[0]] === 'undefined') {
      queryString[pair[0]] = decodeURIComponent(pair[1]);
      // If second entry with this name
    } else if (typeof queryString[pair[0]] === 'string') {
      let arr = [queryString[pair[0]], decodeURIComponent(pair[1])];
      queryString[pair[0]] = arr;
      // If third or later entry with this name
    } else {
      queryString[pair[0]].push(decodeURIComponent(pair[1]));
    }
  }
  if(all === 'all') {
    return queryString;
  } else {
    return queryString[name];
  }
}

const findContent = (source) => {
  let type = location.pathname.match(/^\/[^\/]*/g)[0].substr(1)
  let queryObj = getParameter(null, "all")
  let dataSource = source || queryObj.data
  return topic.get(`data/${type}/${dataSource}`)
}

const getCookie = (name) => {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const clipImage = (image, widthStr) => {
  let webp = getCookie('webp')
  let width = widthStr ? (webp === '1' ? `/wp${widthStr}` : `/w${widthStr}`) : ''
  return image + width
}

// 手机号码脱敏

String.prototype.desensitizationByTel=function(){
  // var str="18912341234"
  let pat=/(\d{3})\d*(\d{4})/
  let b=this.replace(pat,'$1****$2');
  return b;
}

String.prototype.toFormatOSSImage = function (size, remSize) {
  let webp = getCookie('webp')
  let cdnRegx = /^[\w]*:?\/\/cdn(hn|s)?\.(t\.)?amegroups\.(net|cn)\S+\.[\w]+$/
  let deviceWidth = document.documentElement.clientWidth;
  let formatSize = webp === "1" ? '/wp' : '/w'
  if (deviceWidth <= 750) {
    formatSize += remSize || size
  } else {
    formatSize += size
  }

  // todo:
  if (cdnRegx.test(this)) {
    return `${this.toString()}${formatSize}`
  } else {
    return this.toString()
  }
};


// start request rest
const changeUrl = (params)=>{
  history.pushState({},null,`${location.host}${objectToQueryString(params)}`)

}


export {
  getParameterByName,
  thousands,
  objectToQueryString,
  getParameter,
  findContent,
  getCookie,
  clipImage,
}
